// extracted by mini-css-extract-plugin
export var locationCard = "_eb-0";